import { PaginationState, RowSelectionState } from "@tanstack/react-table"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { FindAgecComplianceResponseDto } from "~/gen/api"
import { useAgecColumns } from "~/pages/Brand/Regulations/AGEC/columns"

export type Props = {
  hasAgecComplianceFeatureAccess: boolean
  rowSelection: RowSelectionState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>
  pageCount: number
  products: FindAgecComplianceResponseDto[]
  pagination: PaginationState
}

export const useAgecTable = ({
  hasAgecComplianceFeatureAccess,
  rowSelection,
  setPagination,
  setRowSelection,
  pageCount,
  products,
  pagination,
}: Props) => {
  const columns = useAgecColumns(hasAgecComplianceFeatureAccess)

  const table = useCustomReactTable({
    data: products,
    columns,
    initialColumnPinning: {
      left: ["name", "reference"],
    },
    state: {
      pagination,
      rowSelection,
    },
    getRowId: (row) => row.id,
    pageCount,
    manualPagination: true,
    enableRowSelection: true,
    onPaginationChange: setPagination,
    onRowSelectionChange: setRowSelection,
  })

  return table
}
